import { useEffect, useMemo, useState } from "react"
import { FiSearch, FiBookOpen } from "react-icons/fi"
import { VscAdd } from "react-icons/vsc"
import { useNavigate } from "react-router-dom"
import { useSelector } from "react-redux"

import { getAllCourses } from "../../../services/operations/courseDetailsAPI"
import IconBtn from "../../common/IconBtn"
import AdminCoursesTable from "./InstructorCourses/AdminCoursesTable"

export default function AllCourses() {
  const { token } = useSelector((state) => state.auth)
  const navigate = useNavigate()
  const [courses, setCourses] = useState([])
  const [loading, setLoading] = useState(true)
  const [search, setSearch] = useState("")

  useEffect(() => {
    const fetchCourses = async () => {
      setLoading(true)
      const result = await getAllCourses(token)
      if (result) setCourses(result)
      setLoading(false)
    }
    fetchCourses()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  const filtered = useMemo(() => {
    const q = search.toLowerCase()
    return courses.filter(
      (c) =>
        c.courseName?.toLowerCase().includes(q) ||
        c.instructor?.firstName?.toLowerCase().includes(q) ||
        c.instructor?.lastName?.toLowerCase().includes(q)
    )
  }, [courses, search])

  return (
    <div className="space-y-6">
      {/* Header */}
      <div className="flex flex-col gap-3 sm:flex-row sm:items-center sm:justify-between">
        <div>
          <h1 className="text-2xl font-bold text-richblack-5">All Courses</h1>
          <p className="text-sm text-richblack-400">
            {loading ? "Loading…" : `${courses.length} courses on the platform`}
          </p>
        </div>
        <div className="flex items-center gap-3">
          <div className="relative">
            <FiSearch size={15} className="absolute left-3 top-1/2 -translate-y-1/2 text-richblack-400" />
            <input
              value={search}
              onChange={(e) => setSearch(e.target.value)}
              placeholder="Search courses…"
              className="form-style w-full pl-9 sm:w-60"
            />
          </div>
          <IconBtn text="Add Course" onclick={() => navigate("/dashboard/add-course")}>
            <VscAdd />
          </IconBtn>
        </div>
      </div>

      {/* Empty state */}
      {!loading && filtered.length === 0 && (
        <div className="flex flex-col items-center gap-3 py-24">
          <FiBookOpen size={40} className="text-richblack-600" />
          <p className="text-richblack-400">
            {search ? "No courses match your search" : "No courses on the platform yet"}
          </p>
        </div>
      )}

      {/* Table */}
      {(loading || filtered.length > 0) && (
        <AdminCoursesTable courses={filtered} setCourses={setCourses} />
      )}

      {/* Footer count */}
      {!loading && filtered.length > 0 && search && (
        <p className="text-center text-xs text-richblack-500">
          Showing {filtered.length} of {courses.length} courses
        </p>
      )}
    </div>
  )
}
